export function filterNull<T>(arg: T | null): arg is T {
  return arg !== null
}

export function filterUndefined<T>(arg: T | undefined): arg is T {
  return arg !== undefined
}

export function filterNullOrUndefined<T>(arg: T | undefined): arg is T {
  return arg !== undefined || arg !== null
}
